import type { PeekPriceLargeHotelCardData } from './accommodation';
import type { PeekPriceMultiIngredientCard } from './multiIngredient';
import type { PeekPriceMediumBookableTransportCardData } from './transport';

export const enum PeekPriceModalItineraryType {
  HotelOnly = 'hotelOnly',
  FlightPlusHotel = 'flightPlusHotel',
  UnavailableFlightPlusHotel = 'unavailableFlightPlusHotel',
  FerryPlusHotel = 'ferryPlusHotel',
  UnavailableFerryPlusHotel = 'unavailableFerryPlusHotel',
  MultiIngredient = 'multiIngredient',
}

export interface PeekPriceModalHotelOnlyItinerary {
  type: PeekPriceModalItineraryType.HotelOnly;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  hotel: PeekPriceLargeHotelCardData;
}

export interface PeekPriceModalFlightPlusHotelItinerary {
  type: PeekPriceModalItineraryType.FlightPlusHotel;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  departureTransport: PeekPriceMediumBookableTransportCardData;
  hotel: PeekPriceLargeHotelCardData;
  arrivalTransport: PeekPriceMediumBookableTransportCardData;
}

export interface PeekPriceModalFerryPlusHotelItinerary {
  type: PeekPriceModalItineraryType.FerryPlusHotel;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  departureTransport: PeekPriceMediumBookableTransportCardData;
  hotel: PeekPriceLargeHotelCardData;
  arrivalTransport: PeekPriceMediumBookableTransportCardData;
}

export interface PeekPriceModalMultiIngredientItinerary {
  type: PeekPriceModalItineraryType.MultiIngredient;
  paxes: string;
  dates: string | undefined;
  price: string | undefined;
  inspectedAccommodationName: string;
  cards: PeekPriceMultiIngredientCard[];
}

export type PeekPriceModalItineraryData =
  | PeekPriceModalHotelOnlyItinerary
  | PeekPriceModalFlightPlusHotelItinerary
  | PeekPriceModalFerryPlusHotelItinerary
  | PeekPriceModalMultiIngredientItinerary;
